module.exports = __webpack_public_path__ + "media/src/images/icons/gray-copy-448101852c51b7d9ecc30900bf629eba.svg";